"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpCarouselControl = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_bootstrap_1 = require("react-bootstrap");
var react_i18next_1 = require("react-i18next");
var Icon_1 = require("../Icon/Icon");
var DpCarouselControl_styled_1 = require("./DpCarouselControl.styled");
var DpCarouselControl = function (_a) {
    var label = _a.label, navigateHandler = _a.navigateHandler, _b = _a.useLabel, useLabel = _b === void 0 ? true : _b, controlPosition = _a.controlPosition, customClass = _a.customClass, _c = _a.id, id = _c === void 0 ? 'control' : _c, cardNumber = _a.cardNumber, total = _a.total, ariaLabelName = _a.ariaLabelName;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var icon = label === 'previous' ? 'chevron-back' : 'chevron-front';
    var labelWrapper = (0, jsx_runtime_1.jsx)("span", { id: "label-".concat(id), children: label });
    var variant = customClass ? undefined : 'light';
    return ((0, jsx_runtime_1.jsxs)(DpCarouselControl_styled_1.StyledCarouselControl, { className: controlPosition, children: [useLabel && label === 'next' && labelWrapper, (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { id: "nav-".concat(label, "-").concat(id), variant: variant, className: "bg-white border-white ".concat(customClass), onClick: navigateHandler, "aria-label": t('carousel.ariaLabel.control', {
                    control: label,
                    name: ariaLabelName,
                    num: cardNumber,
                    total: total,
                }), "data-testid": "nav-".concat(label, "-").concat(id), children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon }) }), useLabel && label === 'previous' && labelWrapper] }));
};
exports.DpCarouselControl = DpCarouselControl;
exports.default = exports.DpCarouselControl;
